import { getDate } from '@sequencehq/utils/dates'

export const getRecurrenceDateForPhases = (args: {
  recurrenceDayOfMonth: number
  phases: Array<{
    startDate: Date
    recurrencePreference: 'CONTINUE_FROM_PREVIOUS_PHASE' | 'RESET'
  }>
}): Array<{ recurrenceDayOfMonth: number }> => {
  return args.phases.reduce(
    (acc, p) => {
      if (p.recurrencePreference === 'RESET') {
        return [
          ...acc,
          {
            recurrenceDayOfMonth: getDate(p.startDate)
          }
        ]
      }

      const previousPhaseRecurrenceDayOfMonth =
        acc.at(-1)?.recurrenceDayOfMonth ?? args.recurrenceDayOfMonth
      return [
        ...acc,
        { recurrenceDayOfMonth: previousPhaseRecurrenceDayOfMonth }
      ]
    },
    [] as Array<{ recurrenceDayOfMonth: number }>
  )
}
